export const PATHS = {
    root: '/',
    sample: '/user/sample',
    signup: '/signup',
    signin: '/signin',
    profile: '/my/profile',
    home: '/user/home',
    notes: '/user/notes',
    tasks: '/user/tasks',
    posts: '/my/posts',
    myCategories: '/my/categories',
    users: '/users',
    publish: '/user/publish',
    popular: '/user/popular',
    tags: '/user/tags',
    communities: '/user/communities',
    seeLater: '/user/see-later',
}